export default __webpack_public_path__ + "static/media/AdminConsoleBuildAndRelease.41f2db08.yml";